import LowCostView from './LowCostView'
import NoChoicesView from './NoChoicesView'
import NoiseView from './NoiseView'
import SelectorView from './SelectorView'
import PurifierDetailView from './PurifierDetailView'

export default {
  LowCostView, NoiseView, NoChoicesView, SelectorView, PurifierDetailView
}



// WEBPACK FOOTER //
// ./src/components/index.js